import React, {useState, useEffect} from "react";
import { makeStyles } from "@material-ui/styles";
import PropTypes from 'prop-types';
import RoomUpdateForm from "./RoomUpdateForm";
import { SIREN_CONFIG } from 'config.js';
import {useSelector} from 'react-redux';


const RoomUpdate = (props) => {

  const {className, match, history, ...rest } = props;
  const classes = useStyles();

  const [roomInfo, setRoomInfo] = useState(null);
  const facility_id = useSelector((store) => store.user.facility_id);

  const loadData = (roomId) => {

    var url = `${SIREN_CONFIG.HOSTNAME}/room/roomInfo?facility_id=${facility_id}&roomId=${roomId}`;

    fetch(url)
    .then(res => res.json())
    .then(snapshot => {

      setRoomInfo({
        roomId: snapshot.resultData[0].roomId,
        roomName: snapshot.resultData[0].roomName,
        roomType: snapshot.resultData[0].roomType,
        // caregiver1_id: snapshot.resultData[0].caregiver1_id,
        // caregiver2_id: snapshot.resultData[0].caregiver2_id,
      });

    }
    );
  }

  useEffect( () => {
    loadData(match.params.roomId);
  }, []);


  return (
    <div className={classes.root}>
      <div className={classes.content}>
        { roomInfo && <RoomUpdateForm roomInfo={roomInfo} history={history} /> }
      </div>
    </div>
  );
};


RoomUpdate.propTypes = {
  history: PropTypes.object
};

export default RoomUpdate;


const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  content: {
    marginTop: theme.spacing(2),
  },
}));